let currentUtm;
// Function to set the utm's data
export function setUtmData(utm) {
    currentUtm = utm;
}
// Function to get the utm's data
export function getUtmData() {
    return currentUtm;
}
